export default __webpack_public_path__ + "static/media/Gesundheitliche.e47c6ea9.md";